/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetTenantRestrictionsByTenantIDOptions,
  GetTenantRestrictionsByTenantIDResponses,
} from '../types/GetTenantRestrictionsByTenantID'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get tenant restrictions by tenant ID
 * {@link /v1/tenants/:tenant_id/restrictions}
 */
export function getTenantRestrictionsByTenantID<ThrowOnError extends boolean = true>(
  options: Options<GetTenantRestrictionsByTenantIDOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetTenantRestrictionsByTenantIDResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/tenants/{tenant_id}/restrictions',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTenantRestrictionsByTenantIDResponses, ThrowOnError>>,
  )
}
